import React, { useEffect, useState } from 'react';
import Widget from "../UI/Widget";
import List from "../UI/List";

import {useContactInfo} from './../../queries/footerContactInfo';
import {useSocialMedia} from './../../queries/footerSocialMedia';
import {useRelatedCompanies} from './../../queries/footerRelatedCompanies';
import {useCompanyLogo} from './../../queries/companyLogo';
import InfinitProgressBar from '../InfiniteProgressBar';
import {getImagesWithAbsolutePath, myDomain} from '../../helpers/urlHelper';

function Footer() {




    const contactData = useContactInfo();
    const  relatedData = useRelatedCompanies();
    const companyLogo= useCompanyLogo();
    const socialData = useSocialMedia();
    if(contactData.loading) return <InfinitProgressBar/>
    if(contactData.error) return <div>error!</div>

    
    if(relatedData.loading) return <InfinitProgressBar/>
    if(relatedData.error) return <div>error!</div>

    if(companyLogo.loading) return <InfinitProgressBar/>
    if(companyLogo.error) return <div>error!</div>

    if(socialData.loading) return <InfinitProgressBar/>
    if(socialData.error) return <div>error!</div>
      

    return (
        <footer className="footer-area sp-bottom" style={{backgroundColor:"#333333eb"}}>
            <div className="container">
                <div className="row mtn-40">
                    {
                        contactData.data.footerContactInfo.map(i=>
                            <div className="col-lg-4 order-4 order-lg-0">
                                <div className="widget-item">
                                    <div className="about-widget">
                                        <Widget style={{color:'#fff'}} title={i.displayText}>
                                            <List classes="widget-list">
                                                <p style={{fontSize:"14px", color:"#fff"}} dangerouslySetInnerHTML={{__html: i.address.html}}/>
                                                <p style={{direction:'ltr',fontSize:"13px", color:"#fff"}} dangerouslySetInnerHTML={{__html: i.phone.html}}/>
                                                {
                                                    i.fax !== null?
                                                    <p style={{direction:'ltr',fontSize:"13px", color:"#fff"}} dangerouslySetInnerHTML={{__html: i.fax.html}}/>
                                                    :
                                                    null
                                                }
                                                <p style={{direction:'ltr',fontSize:"13px", color:"#fff"}} dangerouslySetInnerHTML={{__html: i.pOBox.html}}/>
                                                <p style={{direction:'ltr',fontSize:"13px", color:"#fff"}} dangerouslySetInnerHTML={{__html: i.postalCode.html}}/>
                                                
                                            </List>
                                        </Widget>
                                    </div>
                                </div>
                            </div>
                        )
                    }

                    {/* <div className="col-md-4 col-lg-2 ml-auto">
                        <Widget title="اطلاعات تماس دفتر مرکزی و کارخانه">
                            <List classes="widget-list">
                                {
                                    FooterContactInfo.map(i=>
                                        <>
                                            <LI><Link to={`${localhost:3000 + "/about"}`}><div dangerouslySetInnerHTML={{__html: i.address.html}}/></Link></LI>
                                            <LI><Link to={`${localhost:3000 + "/contact"}`}>تماس با ما</Link></LI>
                                            <LI><Link to={`${localhost:3000 + "/services"}`}>خدمات ما</Link></LI>
                                            <LI><Link to={`${localhost:3000 + "/"}`}>فرصت های شغلی</Link></LI>
                                        </>
                                    )
                                }
                            </List>
                        </Widget>   
                    </div> */}

                    <div className="col-lg-4 order-4">
                        <Widget title="شرکت های وابسته">
                            <List classes="widget-list">
                                {
                                    relatedData.data.footerRelatedCompanies.map(i=>
                                        <>
                                            <h6 style={{fontWeight:'bold', color:'#fff'}} dangerouslySetInnerHTML={{__html: i.displayText}}/>
                                            
                                            <p style={{fontSize:"14px", color:'#fff'}} dangerouslySetInnerHTML={{__html: i.address.html}}/>
                                            <p style={{direction:'ltr', fontSize:"13px", color:'#fff'}} dangerouslySetInnerHTML={{__html: i.phone.html}}/>
                                            <p style={{direction:'ltr', fontSize:"13px", color:'#fff'}} dangerouslySetInnerHTML={{__html: i.fax.html}}/>
                                           
                                        </>
                                        )
                                }
                               
                            </List>
                        </Widget>
                    </div>

                   
                </div>
                <hr style={{width:'100%', height:'1px', backgroundColor:'#e5e5e5'}}/>
                <div className="row" >
                    {
                        socialData.data.footerSocialMedia.map(i=>
                           <div dangerouslySetInnerHTML={{__html: getImagesWithAbsolutePath(i.htmlBody.html, myDomain)}} style={{margin:"0 2%", color:"#000", fontSize:"30px"}} />
                            )
                    }
                </div>
            </div>
        </footer>
    );
}

export default Footer;
